/** @format */
import { Box, Button } from "@mui/material";
import DynamicIcon from "dynamicicon";
import { useLocales } from "locales";
import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";

export default function Video(props) {
  const [playing, setPlaying] = useState(false);
  const playerRef = useRef(null);

  const { t } = useLocales();

  const { url, autoplay, onEnded, thumb, buttonText = false, button = {} } = props;

  useEffect(() => {
    if (autoplay) {
      setPlaying(true);
    }
  });

  const handlePlay = () => {
    setPlaying(true);
  };

  const onVideoEnded = () => {
    setPlaying(false);

    // Reset timestamp to 0
    playerRef.current.seekTo(0);

    if (onEnded) onEnded();
  };

  if (!url) return null;

  return (
    <Box sx={{ position: "relative", padding: "20px 0" }}>
      <Box sx={{ opacity: !playing && !thumb ? 0.25 : 1, borderRadius: "5px", overflow: "hidden" }} boxShadow={1}>
        <ReactPlayer
          ref={playerRef}
          url={url}
          playing={playing}
          controls={false}
          width="100%"
          height="100%"
          onEnded={onVideoEnded}
        />
        {!playing && thumb && (
          <Box
            component="img"
            loading="lazy"
            src={thumb}
            alt="Made Live Movie Thumbnail"
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: 1,
              opacity: 1,
            }}
          />
        )}
      </Box>
      {!playing && (
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2,
          }}
        >
          <Button variant="contained" size="large" color="success" onClick={handlePlay} {...button}>
            {buttonText ? t(buttonText) : <DynamicIcon icon="fa-play" />}
          </Button>
        </Box>
      )}
    </Box>
  );
}
